import { render, staticRenderFns } from "./AtomChip.vue?vue&type=template&id=5a8ddb14&scoped=true&functional=true&"
import script from "./AtomChip.vue?vue&type=script&lang=ts&"
export * from "./AtomChip.vue?vue&type=script&lang=ts&"
import style0 from "./AtomChip.vue?vue&type=style&index=0&id=5a8ddb14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5a8ddb14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
